import { RimmEntityType } from '../data/rimmEntityEnums';

const defaultSelectFields = ['code', 'description'];
const companySelectFields = ['code', 'description', 'email', 'phoneNumber', 'address1', 'address2'];
const exchangeRateSelectFields = ['code', 'description', 'rate'];
const commodityCodeSelectFields = [
  'code',
  'description',
  'supplementaryUnit1Code',
  'supplementaryUnit2Code',
  'supplementaryUnit3Code',
];

function getSelectFieldsByEntity(entity: RimmEntityType) {
  switch (entity) {
    case RimmEntityType.company:
      return companySelectFields;
    case RimmEntityType.exchangeRate:
      return exchangeRateSelectFields;
    case RimmEntityType.commodity:
      return commodityCodeSelectFields;
    default:
      return defaultSelectFields;
  }
}

export default getSelectFieldsByEntity;
